import { CTA, Description, Title } from "@/ui";
import clsx from "classnames";
import { Col, Container, Row } from "react-bootstrap";
import classes from "./styles.module.scss";
import ArrowLeft from "@/assets/ArrowLeft.svg";

export const HeaderTextOverlay = ({
  className,
  containerClassName,
  title,
  img,
  description,
  showCta,
  cta,
  showBackLink,
  back,
  bgColor,
  textColor,
}) => {
  return (
    <div className={clsx(className, classes.header, { "has-img": img }, `bg-${bgColor}`, `text-${textColor}`)}>
      <img className={classes.header__img} src={img?.url} alt={img?.alt} />
      <div className={clsx(classes.header__body, "py-3 p-md-5")}>
        <Container className={containerClassName}>
          <Row>
            <Col xs={12} md={8}>
              {showBackLink && (
                <a className={clsx(classes.back, "mb-3")} href={back.href}>
                  <ArrowLeft />
                  {back.placeholder}
                </a>
              )}
              <Title className="mb-0" title={title} tag="h1" />
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={4}>
              <Description className="mt-4" description={description} />
              {showCta && <CTA className="mt-4" label={cta.label} href={cta.href} variant={cta.variant} />}
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default HeaderTextOverlay;
